/*
  Static image slider — extracted from sections/image-slider.liquid so it ships from a cacheable, deferred asset
  instead of inline markup. DOMContentLoaded-gated and guarded by data-ks-init.
*/

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".static-image-container .static-slider").forEach(function (sliderEl) {
    if (sliderEl.dataset.ksInit === "true") return;

    var container = sliderEl.closest(".static-image-container");

    // Get ALL matching buttons (desktop + mobile)
    var toggleBtns = container.querySelectorAll(".nav-toggle");
    var prevBtns = container.querySelectorAll(".nav-prev");
    var nextBtns = container.querySelectorAll(".nav-next");

    // Initialize Keen slider
    var slider = new KeenSlider(sliderEl, {
      loop: true,
      slides: { perView: 3.0, spacing: 16 },
      renderMode: "performance",
      mode: "free",
      breakpoints: {
        "(max-width: 768px)": { slides: { perView: 1.5, spacing: 16 } }
      },
      created: function () {
        if (typeof updateDivHeights === "function") updateDivHeights();
      },
      slideChanged: function () {
        if (typeof updateDivHeights === "function") updateDivHeights();
      },
      resize: function () {
        if (typeof updateDivHeights === "function") updateDivHeights();
      }
    });

    sliderEl.dataset.ksInit = "true";

    // Add click events for all prev buttons
    for (var i = 0; i < prevBtns.length; i++) {
      prevBtns[i].addEventListener("click", function (e) {
        e.preventDefault();
        slider.prev();
      });
    }

    // Add click events for all next buttons
    for (var j = 0; j < nextBtns.length; j++) {
      nextBtns[j].addEventListener("click", function (e) {
        e.preventDefault();
        slider.next();
      });
    }

    var playing = true;
    var autoplayTimer;

    function startAutoplay() {
      stopAutoplay(); // clear old timer
      autoplayTimer = setInterval(function () {
        slider.next();
      }, 4000);
      playing = true;
      updateToggleButtons();
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
      playing = false;
      updateToggleButtons();
    }

    function updateToggleButtons() {
      for (var k = 0; k < toggleBtns.length; k++) {
        var btn = toggleBtns[k];
        btn.dataset.state = playing ? "playing" : "paused";
        btn.setAttribute("aria-pressed", playing ? "true" : "false");
        btn.setAttribute("aria-label", playing ? "Pause slideshow" : "Play slideshow");
      }
    }

    // Add click events for ALL play/pause buttons
    for (var k = 0; k < toggleBtns.length; k++) {
      toggleBtns[k].addEventListener("click", function () {
        if (playing) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
    }

    // Start autoplay by default
    startAutoplay();
  });
});
